import React from 'react';
import FullView from '../common/FullView';
import { Link } from 'react-router-dom';

function PageNotFound() {
    return (
      <FullView className="common-page-not-found uk-flex uk-flex-center uk-flex-middle">
        <h1>Page not found</h1>
        <Link to="/">Home</Link>
      </FullView>
    );
  }

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/features/common/PageNotFound.js